export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxbl8c5yjTjQJElti5.38d9176b.woff2";